import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ConfirmationData} from './confirmation-data.model';

@Injectable({
	providedIn: 'root'
})
export class ConfirmationModalService {

	private _ouvertureModal: Subject<ConfirmationData>;
	private _fermetureModal: Subject<void>;

	constructor() {
		this._ouvertureModal = new Subject<ConfirmationData>();
		this._fermetureModal = new Subject<void>();
	}

	ouvrir(confirmationData: ConfirmationData): void {
		this._ouvertureModal.next(confirmationData);
	}

	fermer(): void {
		this._fermetureModal.next();
	}

	ouvertureModal(): Observable<ConfirmationData> {
		return this._ouvertureModal.asObservable();
	}

	fermetureModal(): Observable<void> {
		return this._fermetureModal.asObservable();
	}
}
